<template>
  <div class="container">
    <ErrorMessage v-if="errorMessage" :errorMessage="errorMessage" />
    <div class="form-container pb-5" style="margin-bottom: 15rem">
      <div class="logo-container m-5">
        <div class="m-5 mb-6">
          <a class="navbar-brand" href="/login">
            <img src="/logo.svg" alt="AlloDoctor" class="logo" />
          </a>
        </div>

        <div class="welcome-message">Welcome To Allo Doctor Dashboard</div>
      </div>

      <div class="form m-5 py-4">
        <form
          @submit.prevent="handleSendOtp"
          class="g-3 needs-validation"
          novalidate
        >
          <div class="col-md-12 mb-4">
            <label for="email" class="form-label">Email</label>
            <input
              type="text"
              class="form-control"
              id="email"
              v-model="email"
              required
            />
            <div class="valid-feedback">Looks good!</div>
          </div>

          <div class="col-12 mb-1">
            <button
              class="btn btn-primary mt-3"
              type="submit"
              :disabled="loading"
            >
              <span v-if="!loading">Send OTP</span>
              <span v-else>
                <i class="fas fa-spinner fa-spin"></i> Sending...
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from "axios";
import axios from "../../Axios";
// import { store } from "../../Store"; // Adjust the path as necessary
import ErrorMessage from "../Errors/ErrorMessage.vue";
// import { UIInitializationService } from "@/UIInitializationService";

export default {
  name: "LoginComponent",
  data() {
    return {
      email: "",
      errorMessage: "",
      loading: false, // Add loading state
      mainJsLoaded: false,
    };
  },

  components: {
    ErrorMessage,
  },
  methods: {
    async handleSendOtp() {
      this.loading = true;
      this.errorMessage = "";
      try {
        await axios.post("/admin/auth/otp", { email: this.email });
        this.$router.push({ name: "verify-otp", query: { email: this.email } });
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "Failed to send OTP.";
        setTimeout(() => {
          this.errorMessage = "";
        }, 3500);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Centers logo and text horizontally */
  margin-bottom: 1rem;
  /* Adds space between logo and form */
}

.logo {
  width: 150px;
  height: auto;
  margin-bottom: 10px;
  /* Adds space between logo and welcome message */
}

.welcome-message {
  font-size: 1.5rem;
  text-align: center;
  color: #6b7280;
  font-weight: 500;
}

.form {
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 50%;
  max-width: 500px;
}

form button {
  width: 100%;
  background-color: #1e7dc0;
}
</style>
